import React, { Fragment, useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';

import { ContactLensWishIcon } from '../../components';

import './ContactLensHeaderImage.scss';

export const ContactLensHeaderImage = props => {
  const { baseImageUrl, productData = null } = props;

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const previewRef = useRef(null);
  const navigationRef = useRef(null);

  const imageLength = productData ? productData.imageUrls?.length : 6;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (previewRef.current && navigationRef.current) {
        setNav1(previewRef.current);
        setNav2(navigationRef.current);
      }
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  const previewSetting = {
    infinite: true,
    arrows: false,
    asNavFor: nav2,
    ref: previewRef,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
        },
      },
      {
        breakpoint: 9999,
        settings: {
          dots: false,
        },
      },
    ],
  };

  const navigationSetting = {
    arrows: false,
    adaptiveHeight: true,
    asNavFor: nav1,
    ref: navigationRef,
    focusOnSelect: true,
    slidesToScroll: 1,
    slidesToShow: imageLength > 5 ? 5 : imageLength,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          variableWidth: true,
          vertical: false,
          verticalSwiping: false,
          centerMode: false,
        },
      },
    ],
  };

  const renderIcons = () => {
    const renderTags = tags => {
      if (!tags?.length) {
        return null;
      }

      return tags.map(({ label, imageUrl }) => <img key={label} alt={label} src={imageUrl} />);
    };

    return (
      <Fragment>
        <div className="contact-lens-header-image__main__icon-heart">
          <ContactLensWishIcon productId={productData?.id} />
        </div>

        <div
          className="contact-lens-header-image__main__icon-tag"
          data-is-custom-tags={Boolean(productData?.customTags?.length)}
        >
          {productData ? (
            <>
              {renderTags(productData?.sortingTag)}
              {renderTags(productData?.customTags)}
            </>
          ) : (
            // Mockup
            <img alt="Bestseller" src={`${baseImageUrl}/icons/bestseller.svg`} />
          )}
        </div>
      </Fragment>
    );
  };

  const renderPreview = () => {
    // original no image url
    const noImageUrl = 'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg';

    const renderImages = () => {
      if (productData) {
        const images =
          productData.imageUrls && productData.imageUrls.length > 0
            ? productData.imageUrls
            : [noImageUrl];

        return images.map((url, index) => (
          <picture key={index}>
            <source media="(min-width: 768px)" srcSet={url || noImageUrl} />
            <img alt={productData.title} src={url || noImageUrl} />
          </picture>
        ));
      }

      // Mockup placeholders when productData is not available
      return Array.from({ length: imageLength }).map((_, index) => (
        <picture key={index}>
          <source
            media="(min-width: 768px)"
            srcSet={`${baseImageUrl}/mockup/mockup-clear_pc.webp`}
          />
          <img alt="" src={`${baseImageUrl}/mockup/mockup-clear_sp.webp`} />
        </picture>
      ));
    };

    return (
      <Fragment>
        <Slider {...previewSetting} className="contact-lens-header-image__main__preview">
          {renderImages()}
        </Slider>

        <div
          className="contact-lens-header-image__main__preview-previous"
          data-length={imageLength}
          onClick={() => previewRef.current?.slickPrev()}
        />
        <div
          className="contact-lens-header-image__main__preview-next"
          data-length={imageLength}
          onClick={() => previewRef.current?.slickNext()}
        />
      </Fragment>
    );
  };

  const renderNavigation = () => {
    // original no image url
    const noImageUrl = 'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg';

    const renderNavigationImages = () => {
      if (productData) {
        const images =
          productData.imageUrls && productData.imageUrls.length > 0
            ? productData.imageUrls
            : [noImageUrl];

        return images.map((url, index) => (
          <img key={index} alt={productData.title} src={url || noImageUrl} />
        ));
      }

      // Mockup placeholders when productData is not available
      return Array.from({ length: imageLength }).map((_, index) => (
        <img key={index} alt="" src={`${baseImageUrl}/mockup/mockup-clear_sp.webp`} />
      ));
    };

    return (
      <div>
        <Slider
          {...navigationSetting}
          className={`contact-lens-header-image__main__navigation contact-lens-header-image__main__navigation__length-${imageLength}`}
        >
          {renderNavigationImages()}
        </Slider>

        <img
          alt="next"
          className="contact-lens-header-image__main__navigation-next"
          data-length={imageLength}
          src={`${baseImageUrl}/icons/next-slider-icon.svg`}
          onClick={() => navigationRef.current?.slickNext()}
        />
      </div>
    );
  };

  return (
    <div className="contact-lens-header-image__main">
      <div className="contact-lens-header-image__main__container">
        {renderIcons()}
        {renderPreview()}
        {renderNavigation()}
      </div>
    </div>
  );
};
